interface Availability {
  start: string
  end: string
  periods: Array<AvailabilityPeriod>
}

export interface AvailabilityPeriod {
  weekdays: Array<Weekday>
  start: string
  end: string
}

export enum Weekday {
  WEEKDAY_MONDAY = 'WEEKDAY_MONDAY',
  WEEKDAY_TUESDAY = 'WEEKDAY_TUESDAY',
  WEEKDAY_WEDNESDAY = 'WEEKDAY_WEDNESDAY',
  WEEKDAY_THURSDAY = 'WEEKDAY_THURSDAY',
  WEEKDAY_FRIDAY = 'WEEKDAY_FRIDAY',
  WEEKDAY_SATURDAY = 'WEEKDAY_SATURDAY',
  WEEKDAY_SUNDAY = 'WEEKDAY_SUNDAY',
}

export default Availability
